export class NativeHelper
{
    public static sendNativeEvent(event : string, parameter : { [key : string] : string; })
    {
        var query = "";
        for(var key in parameter)
        {
            if(query.length > 0) { query += "&"; }
            query += key + "=" + parameter[key];
        }
        var url = query.length > 0 ? "native://" + event + "?" + query : "native://" + event;

        // イベントとしてalertを使うか判定
        var userAgent = window.navigator.userAgent.toLowerCase();
        if(userAgent.indexOf("label10_use_alert_as_native_event") >= 0)
        {
            alert(url);
        }
        else
        {
            window.open(url);
        }
    }
}